if (!customElements.get("m-announcement-bar")) {
  // 公告仅需单列循环；百分比位移自动适配宽度，初始化不逐项读取布局。
  class AnnouncementSlider {
    constructor(bar, container) {
      this.bar = bar;
      this.container = container;
      this.wrapper = container.querySelector(".swiper-wrapper");
      this.items = Array.from(this.wrapper.children);
      this.count = this.items.length;
      this.index = 1;
      this.direction = document.documentElement.dir === "rtl" ? 1 : -1;
      this.autoplay = bar.dataset.enableAutoplay === "true";
      this.delay = Math.max(1, parseInt(bar.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.listeners = [];
      this.originalStyle = this.wrapper.getAttribute("style");
      this.originalTouchAction = container.style.touchAction;
      this.originalClasses = container.className;
      this.clones = [this.clone(this.items[this.count - 1]), this.clone(this.items[0])];
      this.wrapper.prepend(this.clones[0]);
      this.wrapper.append(this.clones[1]);
      this.slides = Array.from(this.wrapper.children);
      container.classList.add("swiper-container-initialized", "swiper-container-horizontal");
      container.style.touchAction = "pan-y";
      this.paint(false);
      this.listen(this.wrapper, "transitionend", (event) => {
        if (event.target === this.wrapper && event.propertyName === "transform") this.finish();
      });
      this.listen(bar.querySelector(".swiper-button-next"), "click", () => this.move(1, true));
      this.listen(bar.querySelector(".swiper-button-prev"), "click", () => this.move(-1, true));
      this.listen(container, "pointerdown", (event) => this.pointerDown(event));
      this.listen(container, "pointermove", (event) => this.pointerMove(event));
      this.listen(container, "pointerup", (event) => this.pointerEnd(event));
      this.listen(container, "pointercancel", (event) => this.pointerEnd(event, true));
      this.listen(container, "dragstart", (event) => event.preventDefault());
      this.listen(container, "click", (event) => {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }
      }, true);
      this.listen(document, "visibilitychange", () => this.schedule());
      this.schedule();
    }

    clone(item) {
      const clone = item.cloneNode(true);
      clone.classList.add("swiper-slide-duplicate");
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((node) => node.setAttribute("tabindex", "-1"));
      return clone;
    }

    listen(node, type, handler, options) {
      if (!node) return;
      node.addEventListener(type, handler, options);
      this.listeners.push(() => node.removeEventListener(type, handler, options));
    }

    paint(animate, delta = 0) {
      const transform = `translate3d(calc(${this.direction * this.index * 100}% + ${delta}px), 0, 0)`;
      if (!animate && this.lastTransform === transform) return;
      if (this.wrapper.animate) {
        // 动画效果不逐次修改style属性，避免唤起应用对整页DOM的监听。
        const previous = this.animation;
        this.animation = this.wrapper.animate(
          [{ transform: this.lastTransform || transform }, { transform }],
          { duration: animate ? 300 : 0, fill: "forwards", easing: "ease" }
        );
        this.animation.onfinish = animate ? () => this.finish() : null;
        if (previous) previous.cancel();
      } else {
        this.wrapper.style.transitionDuration = animate ? "300ms" : "0ms";
        this.wrapper.style.transform = transform;
      }
      this.lastTransform = transform;
    }

    finish() {
      clearTimeout(this.transitionTimer);
      this.animating = false;
      if (this.index === 0) this.index = this.count;
      else if (this.index === this.count + 1) this.index = 1;
      this.paint(false);
    }

    move(step, manual = false) {
      if (this.destroyed) return;
      if (manual) this.autoplay = false;
      this.finish();
      this.index += step;
      this.animating = true;
      this.paint(true);
      this.transitionTimer = setTimeout(() => this.finish(), 350);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.autoplayTimer);
      if (this.autoplay && !this.destroyed && !document.hidden && !this.pointer) this.autoplayTimer = setTimeout(() => this.move(1), this.delay);
    }

    pointerDown(event) {
      if (event.isPrimary === false || (event.pointerType === "mouse" && event.button !== 0)) return;
      this.finish();
      this.suppressClick = false;
      // 尺寸只在真实手势开始时读取；首屏初始化无需同步测量。
      this.pointer = {id: event.pointerId, x: event.clientX, y: event.clientY, at: performance.now(), width: this.container.clientWidth};
      clearTimeout(this.autoplayTimer);
    }

    pointerMove(event) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragging) {
        const vertical = Math.abs(event.clientY - pointer.y);
        if (Math.max(Math.abs(delta), vertical) < 5) return;
        if (vertical > Math.abs(delta)) {
          this.pointer = null;
          this.schedule();
          return;
        }
        pointer.dragging = true;
        this.container.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      this.paint(false, delta);
    }

    pointerEnd(event, cancelled = false) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      this.pointer = null;
      if (this.container.hasPointerCapture(event.pointerId)) this.container.releasePointerCapture(event.pointerId);
      const delta = event.clientX - pointer.x;
      if (pointer.dragging) {
        this.suppressClick = true;
        const quickSwipe = performance.now() - pointer.at < 300 && Math.abs(delta) > 20;
        if (!cancelled && (quickSwipe || Math.abs(delta) > pointer.width / 2)) this.move(delta * this.direction > 0 ? 1 : -1, true);
        else { this.paint(true); this.schedule(); }
      } else this.schedule();
    }

    destroy() {
      this.destroyed = true;
      if (this.animation) this.animation.cancel();
      clearTimeout(this.autoplayTimer);
      clearTimeout(this.transitionTimer);
      this.listeners.forEach((remove) => remove());
      this.clones.forEach((clone) => clone.remove());
      this.container.className = this.originalClasses;
      this.container.style.touchAction = this.originalTouchAction;
      if (this.originalStyle === null) this.wrapper.removeAttribute("style");
      else this.wrapper.setAttribute("style", this.originalStyle);
    }
  }

  class MAnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enableSlider !== "true" || (this.slider && !this.slider.destroyed) || this.initFrame != null) return;
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        if (this.isConnected) this.initSlider();
      });
    }

    disconnectedCallback() {
      if (this.initFrame != null) cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      if (this.slider && !this.slider.destroyed) this.slider.destroy();
      this.slider = null;
    }

    initSlider() {
      if (this.slider && !this.slider.destroyed) return;
      const container = this.querySelector(".swiper-container");
      if (container?.querySelector(".swiper-wrapper")?.children.length > 1) this.slider = new AnnouncementSlider(this, container);
    }
  }
  customElements.define("m-announcement-bar", MAnnouncementBar);
}
